import { render, staticRenderFns } from "./permisosError.vue?vue&type=template&id=36087c1f&"
import script from "./permisosError.vue?vue&type=script&lang=js&"
export * from "./permisosError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg,QBanner,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QBanner,QIcon})
